<script>
import Translatable from '@src/mixins/translatable.js'

export default {
  mixins: [Translatable],
  props: {
    card: {
      type: Object,
      required: true,
    },
    isEshop: {
      type: Boolean,
    },
  },
  computed: {
    totalPrice() {
      return (
        this.card.adultCardCount * this.card.adultCard.price +
        this.card.studentCardCount * this.card.studentCard.price
      ).toFixed(2)
    },
    cardName() {
      // const cardTranslation = this.card.name.variants.find(variant => variant.language === this.currentLanguage)
      // return cardTranslation ? cardTranslation.text : this.card.name.default

      return this.card.name.default
        .replace('Day', this.getTranslatedContent('ESHOP_product_name_DAY'))
        .replace('Prague', '')
        .replace('Card', this.getTranslatedContent('ESHOP_product_name_PASS'))
    },
  },
  methods: {
    incrementCount(cardId, cardType, cardTypeId) {
      this.$store.commit('eShop/INCREMENT_CARD_COUNT', {
        cardId,
        cardType,
        cardTypeId,
      })
    },
    decrementCount(cardId, cardType, cardTypeId) {
      this.$store.commit('eShop/DECREMENT_CARD_COUNT', {
        cardId,
        cardType,
        cardTypeId,
      })
    },
  },
}
</script>

<template>
  <div
    class="calculator-container"
    :class="isEshop && 'calculator-container-e'"
  >
    <div class="card-header">
      <div class="card-header-content">
        <h2 class="card-type">
          {{ cardName }}
        </h2>
        <p class="card-subtitle">
          {{ getTranslatedContent('BUY_PRAGUE_CARD_COOL_PASS') }}
        </p>
      </div>
    </div>
    <div class="card-body" :class="isEshop && 'card-body-e'">
      <div class="adult-card-calculator">
        <p class="adult-calculator-label">
          {{ getTranslatedContent('ADULT') }}
        </p>
        <p class="price-label">
          {{ getTranslatedContent('PRICE') }}
        </p>
        <div class="price-section">
          <div v-if="!!card.adultCard.base_price && card.adultCard.price !== card.adultCard.base_price">
            <p class="adult-price orange">
              {{ card.adultCard.price | EUR }}
            </p>
            <p class="adult-price">
              <s>
                {{ card.adultCard.base_price | EUR }}
              </s>
            </p>
          </div>
          <div v-else>
            <p class="adult-price">
              {{ card.adultCard.price | EUR }}
            </p>
          </div>
        </div>
        <div class="calculator">
          <div
            class="decrement-btn"
            @click="
              card.adultCardCount > 0
                ? decrementCount(card.id, 'adult', card.adultCard.id)
                : card.adultCardCount
            "
          >
            <span class="decrement"></span>
          </div>
          <div class="card-count">
            <p
              class="card-counter"
              :class="isEshop && card.adultCardCount && 'orange'"
            >
              {{ card.adultCardCount }}
            </p>
          </div>
          <div
            class="increment-btn"
            @click="incrementCount(card.id, 'adult', card.adultCard.id)"
          >
            <div class="plus">
              <span class="vertical"></span>
              <span class="horizontal"></span>
            </div>
          </div>
        </div>
      </div>
      <div class="child-card-calculator">
        <p class="student-calculator-label">
          {{ getTranslatedContent('STUDENT_CHILD') }}
        </p>
        <div class="price-section">
          <div v-if="!!card.studentCard.base_price && card.studentCard.price !== card.studentCard.base_price">
            <p class="student-price orange">
              {{ card.studentCard.price | EUR }}
            </p>
            <p class="student-price">
              <s>
                {{ card.studentCard.base_price | EUR }}
              </s>
            </p>
          </div>
          <div v-else>
            <p class="student-price">
              {{ card.studentCard.price | EUR }}
            </p>
          </div>
        </div>
        <div class="calculator">
          <div
            class="decrement-btn"
            @click="
              card.studentCardCount > 0
                ? decrementCount(card.id, 'child', card.studentCard.id)
                : card.studentCardCount
            "
          >
            <span class="decrement"></span>
          </div>
          <div class="card-count">
            <p
              class="card-counter"
              :class="isEshop && card.studentCardCount && 'orange'"
            >
              {{ card.studentCardCount }}
            </p>
          </div>
          <div
            class="increment-btn"
            @click="incrementCount(card.id, 'child', card.studentCard.id)"
          >
            <div class="plus">
              <span class="vertical"></span>
              <span class="horizontal"></span>
            </div>
          </div>
        </div>
      </div>
      <div class="total-price-section">
        <div class="total-price">
          <p class="total-price-label">{{
            getTranslatedContent('YOUR_PRICE')
          }}</p>
          <p class="price" :class="isEshop && totalPrice > 0 && 'orange'">{{
            totalPrice | EUR
          }}</p>
        </div>
      </div>
    </div>
    <div v-if="!isEshop" class="card-footer">
      <router-link :to="{ name: 'eshop' }">
        <p class="footer-text">
          {{ getTranslatedContent('CALCULATOR_COMPLETE_BOOKING_BTN') }}
        </p>
      </router-link>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import '@design';

.total-price-section {
  position: relative;
}
.calculator-container {
  // height: 395px;
  width: 355px;
  &.calculator-container-e {
    // height: fit-content;
  }
}

.card-header {
  height: 96px;
  background: $dark-blue;
  border-radius: 10px 10px 0 0;
  width: 340px;
  padding: 8px;
}

.card-body {
  height: 210px;
  display: flex;
  flex-direction: column;
  background: #f9f9fb;
  width: 340px;
  padding: 8px;
  align-items: center;
  justify-content: space-between;
}

.card-footer {
  height: 60px;
  background: $orange;
  border-radius: 0px 0px 10px 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;

  & a {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    text-decoration: none;
  }
}

.card-footer:hover {
  background: $hover-orange;
}

.card-header-content {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.card-type {
  font-family: Open Sans Bold, sans-serif;
  font-weight: bold;
  font-size: 26px;
  line-height: 34px;
  text-transform: uppercase;
  color: white;
  margin-top: 19px;
}

.card-subtitle {
  font-family: Open Sans Semibold, sans-serif;
  font-weight: 600;
  font-style: normal;
  font-size: 14px;
  line-height: 18px;
  color: #ffffff;
  margin-top: 4px;
}

.adult-card-calculator,
.child-card-calculator {
  // margin-left: 25px;
  position: relative;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  // min-height: 52px;
  height: auto;
  width: 327px;
}

.adult-card-calculator {
  margin-bottom: 15px;
  margin-top: 22px;
}

.calculator-label-mixin {
  font-family: Open Sans Semibold, sans-serif;
  font-weight: 600;
  font-size: 16px;
  line-height: 21px;
  color: $dark-blue;
  word-wrap: break-word;
  min-width: 64px;
  width: 64px;
}

.adult-calculator-label {
  @extend .calculator-label-mixin;
  // margin-top: 26px;
}

.student-calculator-label {
  @extend .calculator-label-mixin;
  margin-top: 5px;
}

.price-section {
  font-family: Open Sans, sans-serif;
  font-weight: normal;
  font-size: 14px;
  line-height: 23px;
  color: rgb(37, 44, 62, 0.8);
  display: flex;
  flex-direction: column;
  // margin-left: 17px;
  text-align: center;
}

.price-mixin {
  font-family: Open Sans Bold, sans-serif;
  font-style: normal;
  font-weight: bold;
  font-size: 16px;
  line-height: 21px;
  color: $dark-blue;
  width: 55px;
}

.adult-price {
  &.orange {
    color: $orange;
  }
  @extend .price-mixin;
  margin-top: 4px;
  width: 90px;
}

.student-price {
  &.orange {
    color: $orange;
  }
  @extend .price-mixin;
  margin-top: 4px;
  width: 90px;
}

.btn-mixin {
  position: relative;
  width: 48px;
  height: 48px;
  background: #ffffff;
  cursor: pointer;
}

.card-count {
  display: flex;
  justify-content: center;
  align-items: center;
  background: #ffffff;
  height: 48px;
  width: 64px;
  box-shadow: -3px 0px 2px rgba(207, 206, 221, 0.08);
}

.decrement-btn {
  @extend .btn-mixin;
  border-radius: 4px 0 0 4px;
  display: flex;
  justify-content: center;
  align-items: center;
  box-shadow: 3px 0px 2px rgba(207, 206, 221, 0.08);
}

.increment-btn {
  @extend .btn-mixin;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 0px 4px 4px 0px;
  box-shadow: -3px 0px 2px rgba(207, 206, 221, 0.08);
}

.calculator {
  display: flex;
  flex-direction: row;
  // margin-left: 31px;
  margin-top: 2px;
  justify-content: center;
  align-items: center;
}

.card-counter {
  font-family: Open Sans Bold, sans-serif;
  font-style: normal;
  font-weight: bold;
  font-size: 18px;
  line-height: 23px;
  text-transform: uppercase;
  color: $dark-blue;

  &.orange {
    color: $orange;
  }
}

.decrement {
  height: 0px;
  max-height: 0;
  width: 14px;
  border: 1px solid $dark-blue;
  background-color: $dark-blue;
  border-radius: 1px;
}

.plus {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;

  .vertical {
    position: absolute;
    width: 0;
    height: 14px;
    border: 1px solid $dark-blue;
    background-color: $dark-blue;
    border-radius: 1px;
  }

  .horizontal {
    @extend .decrement;
    position: absolute;
  }
}

.total-price {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  width: auto;
  margin-top: 19px;
  // margin-right: 62px;
  margin-bottom: 18px;
  align-items: center;
  text-align: center;
}

.price-label {
  font-family: Open Sans, sans-serif, sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 18px;
  line-height: 23px;
  color: $dark-blue;
  position: absolute;
  top: -22px;
  left: 94px;
  // margin-right: 5px;
}

.total-price-label {
  font-family: Open Sans, sans-serif, sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 18px;
  line-height: 23px;
  color: $dark-blue;
  margin-right: 5px;
}

.price {
  font-family: Open Sans Bold, sans-serif;
  font-style: normal;
  font-weight: bold;
  font-size: 18px;
  line-height: 23px;
  text-transform: uppercase;
  color: $dark-blue;

  &.orange {
    color: $orange;
  }
}

.footer-text {
  font-family: 'Open Sans Semibold', sans-serif; // temp-text
  font-weight: 600;
  // font-family: "Open Sans", sans-serif;
  // font-weight: normal;
  font-size: 15px;
  line-height: 19px;
  text-transform: uppercase;
  color: #ffffff;
}

.card-body-e {
  border-radius: 0px 0px 10px 10px;
}
</style>
